import { render, staticRenderFns } from "./Ordercertificate.vue?vue&type=template&id=832bf94a&scoped=true&"
import script from "./Ordercertificate.vue?vue&type=script&lang=js&"
export * from "./Ordercertificate.vue?vue&type=script&lang=js&"
import style0 from "./Ordercertificate.vue?vue&type=style&index=0&id=832bf94a&scoped=true&lang=css&"
import style1 from "./Ordercertificate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832bf94a",
  null
  
)

export default component.exports